
import PenTool2 from "../../../assets/duotone/PenTool2.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function PenTool2Icon({ className, dataTestid = "PenTool2Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <PenTool2 data-testid={dataTestid} className={classes} {...rest} />
  );
}
